// This is a no-op which is swapped out at build time in non-prod environments.
export const bindTestPanel = () => null;
